import { gql } from "urql";
export const GetPriorityEntryCountQuery = gql `
    query GetPriorityEntryCount($search: PrioritySearchInput!) {
        priorityEntries {
            priorityEntryCount(search: $search)
        }
    }
`;
export const GetPriorityEntryDetailsQuery = gql `
    query GetPriorityEntryDetails($priorityEntryId: String!) {
        priorityEntries {
            priorityEntry(priorityEntryId: $priorityEntryId) {
                priorityEntryId
                isGlobal
                isOriginatingOrganization
                isAdoptingOrganization
                isReferredOrganization
                patientId
                caregiverId
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    preferredLanguages
                    daysAvailable
                    timeAvailable
                    postalCode
                    gradeLevel
                    conditionList {
                        value
                        label
                    }
                    insuranceList {
                        value
                        label
                    }
                    therapyCategoryList {
                        value
                        label
                    }
                    therapySubCategoryList {
                        value
                        label
                    }
                    postalCodeInfo {
                        city
                        stateId
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                caregiver {
                    userId
                    firstName
                    lastName
                    email
                    phoneNumber
                    acceptedTermsConditionsAt
                    createdAt
                    updatedAt
                    isActive
                }
                invitationPending
                providers {
                    userId
                    firstName
                    lastName
                }
                priorityAttribute {
                    priorityAttributeId
                    tags
                    isReferral
                    inquiredAt
                    priorityStatus {
                        priorityStatusId
                        name
                        colorHex
                        isMutable
                        sortOrder
                        throwConfetti
                        simpleEmailTemplateId
                    }
                }
                relatedEntries {
                    priorityEntryId
                    therapyCategoryName
                }
            }
        }
    }
`;
export const ExportPriorityEntriesQuery = gql `
    query ExportPriorityEntries($priorityViewId: String!) {
        priorityEntries {
            exportPriorityEntries(priorityViewId: $priorityViewId) {
                priorityEntryId
                caregiver {
                    userId
                    firstName
                    lastName
                    email
                    phoneNumber
                }
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    postalCodeInfo {
                        city
                        stateId
                        postalCode
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
                priorityAttribute {
                    priorityAttributeId
                    inquiredAt
                    priorityStatus {
                        priorityStatusId
                        name
                    }
                }
            }
        }
    }
`;
export const GetPriorityEntrySearchResultsQuery = gql `
    query GetPriorityEntrySearchResults(
        $search: PrioritySearchInput!
        $matchTherapyCategory: Boolean
    ) {
        priorityEntries {
            priorityEntries(search: $search) {
                priorityEntryId
                isGlobal
                isOriginatingOrganization
                isAdoptingOrganization
                isReferredOrganization
                caregiver {
                    userId
                    firstName
                    lastName
                }
                patient {
                    patientId
                    firstName
                    lastName
                    dateOfBirth
                    postalCodeInfo {
                        city
                        stateId
                        postalCode
                    }
                }
                invitationPending
                providers(matchTherapyCategory: $matchTherapyCategory) {
                    userId
                    firstName
                    lastName
                }
                priorityAttribute {
                    priorityAttributeId
                    priorityStatus {
                        priorityStatusId
                        name
                        colorHex
                        isMutable
                        simpleEmailTemplateId
                    }
                }
                therapyCategory {
                    therapyCategoryId
                    name
                }
            }
        }
    }
`;
